/**
 * File afterres.js.
 *
 */
( function($) {

	const siteheader = $('.site-header');
	siteheader.stickybits({
        useStickyClasses: true,
    });

    searchForm = $('.search-form');
    searchBtn = $('.search-toggle');

    searchForm.attr( 'aria-expanded', 'false' );

    searchBtn.on('click', function(e) {
        e.stopPropagation();
        if ( searchForm.hasClass( 'toggled' ) ) {
            searchForm.removeClass( 'toggled' );
            searchBtn.attr( 'aria-expanded', 'false' );
            searchForm.attr( 'aria-expanded', 'false' );
        } else {
            searchForm.addClass( 'toggled' );
            searchBtn.attr( 'aria-expanded', 'true' );
            searchForm.attr( 'aria-expanded', 'true' );
        }
    });

    $("body").click(function(e) {
        insideForm = $(e.target).closest(searchForm).length;
        if (!insideForm ) {
            searchForm.removeClass( 'toggled' );
            searchBtn.attr( 'aria-expanded', 'false' );
            searchForm.attr( 'aria-expanded', 'false' );
        }
    });

    $('.bloc-blog .slider').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    $('.bloc-agenda .slider').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

} )(jQuery);
